import React from 'react';
import github from './github.svg';

const IconGitHub2 = () => (
  <div>
    <img src={github} alt="github" />
  </div>
);
export default IconGitHub2;
